import i18n from "../i18n";

/**
 * Fire a global event picked up by <SupportFab/> to open the support panel
 * (Message tab) with a pre-filled property visit request — localized.
 * Also logs the intent to the backend so admins can see demand per property.
 */
export function requestPropertyVisit(property, api) {
  const t = i18n.t.bind(i18n);
  const title = property.title || "";
  const isRent = property.transaction === "Location";
  const message = t("properties.visit_message", {
    title,
    location: property.location ? ` (${property.location})` : "",
    ref: property.agency_ref ? ` — ${property.agency_ref}` : "",
    action: isRent ? t("properties.visit_action_rent") : t("properties.visit_action_buy"),
  });
  // Fire-and-forget — don't block UX if the tracker fails
  if (api?.logVisitRequest) api.logVisitRequest(property.id).catch(() => { /* ignore */ });
  window.dispatchEvent(
    new CustomEvent("support:open", {
      detail: { tab: "message", message, propertyId: property.id, propertyTitle: title },
    }),
  );
}
